if (!customElements.get("video-floating")) {
  customElements.define(
    "video-floating",
    class VideoFloating extends HTMLElement {
      constructor() {
        super();
        this.isFullscreen = false;
        this.isMinimized = false;
        this.isMuted = true;
        this.activeVideoIndex = 0;
        this.draggable = false;
        this.dragOffsetX = 0;
        this.dragOffsetY = 0;
        this.position = 0; // 初始位置
        this.isInit = true;
      }

      connectedCallback() {
        // 初始化元素引用
        this.miniElement = this.querySelector('.video-floating__mini');
        this.fullscreenElement = this.querySelector('.video-floating__fullscreen');
        this.minimizedElement = this.querySelector('.video-floating__minimized');

        this.expandBtn = this.querySelector('.video-floating__expand-btn');
        this.muteBtns = this.querySelectorAll('.video-floating__mute-btn');
        this.minimizeBtn = this.querySelector('.video-floating__minimize-btn');
        this.closeBtn = this.querySelector('.video-floating__close-btn');
        this.minimizedMuteBtn = this.querySelector('.video-floating__minimized-mute-btn');
        this.minimizedCloseBtn = this.querySelector('.video-floating__minimized-close-btn');

        this.muteIcons = this.querySelectorAll('.video-floating__mute-icon');
        this.unmuteIcons = this.querySelectorAll('.video-floating__unmute-icon');
        this.minimizedMuteIcon = this.querySelector('.video-floating__minimized-mute-icon');
        this.minimizedUnmuteIcon = this.querySelector('.video-floating__minimized-unmute-icon');

        // 初始化组件
        this.init();
      }

      init() {
        // 收集视频元素
        this.videoElements = [];
        this.iframeElements = [];
        this.collectVideoElements();

        // 设置浮窗位置
        const section = this.closest('.shopify-section');
        if (section && section.dataset.miniPosition) {
          const miniPosition = section.dataset.miniPosition;
          if (this.miniElement) {
            this.miniElement.classList.add(miniPosition);
          }
        }

        // 初始化轮播图
        // this.initSwipers();

        // 绑定事件
        this.bindEvents();

        // 应用自定义样式
        this.applyCustomStyles();
        this.initPlayButton();

        // 自动播放设置
        const autoplay = section && section.dataset.autoplay === 'true';
        if (autoplay && this.miniElement) {
          this.playMiniVideo();
        }
      }

      initPlayButton() {
        document.querySelectorAll('.video-floating__video-wrapper').forEach(wrapper => {
          const video = wrapper.querySelector('video');
          const playButton = wrapper.querySelector('.video-floating__video-play');

          if (!video || !playButton) return;

          // 初始隐藏播放按钮
          playButton.style.display = 'none';

          // 点击视频区域暂停并显示按钮
          playButton.addEventListener('click', () => {
            video.play();
            playButton.style.display = 'none';
          })
          video.addEventListener('click', (e) => {
            if (!video.paused) {
              video.pause();
              playButton.style.display = 'block';
            } else {
              video.play();
              playButton.style.display = 'none';
            }
          });

          // 点击按钮播放并隐藏按钮
          // playButton.addEventListener('click', (e) => {
          //   e.stopPropagation();
          //   video.play();
          //   playButton.style.display = 'none';
          // });
        });
      }

      collectVideoElements() {
        // 收集浮窗视频
        if (this.miniElement) {
          const miniVideo = this.miniElement.querySelector('video');
          const miniIframe = this.miniElement.querySelector('iframe');
          if (miniVideo) this.videoElements.push(miniVideo);
          if (miniIframe) this.iframeElements.push(miniIframe);
        }

        // 收集全屏视频
        const videoWrappers = this.querySelectorAll('.video-floating__video-wrapper');
        videoWrappers.forEach(wrapper => {
          const video = wrapper.querySelector('video');
          const iframe = wrapper.querySelector('iframe');
          if (video) this.videoElements.push(video);
          if (iframe) this.iframeElements.push(iframe);
        });
      }

      initSwipers() {
        // 初始化视频轮播
        const videosContainer = this.querySelector('.video-floating__videos-swiper');
        if (videosContainer && typeof Swiper !== 'undefined') {
          const isMobile = window.innerWidth <= 1000;
          this.videosSwiper = new Swiper(videosContainer, {
            direction: isMobile ? 'vertical' : 'horizontal',
            slidesPerView: 1,
            spaceBetween: 20,
            // nested: true,
            navigation: {
              nextEl: '.video-floating__videos-next',
              prevEl: '.video-floating__videos-prev',
            },
            on: {
              slideChange: () => {
                console.log(this.videosSwiper.activeIndex, 99)
                this.activeVideoIndex = this.videosSwiper.activeIndex;
                this.updateActiveVideo();
              }
            }
          });
        }

        // 初始化每个视频下方的商品轮播
        const productContainers = this.querySelectorAll('.video-floating__products-swiper');
        if (productContainers.length > 0 && typeof Swiper !== 'undefined') {
          productContainers.forEach(container => {
            new Swiper(container, {
              slidesPerView: 'auto',
              slidesPerGroup: 1,
              spaceBetween: 10,
              nested: true,
              resistanceRatio: 0,
              slidesOffsetBefore: window.innerWidth <= 1000 ? 80 : 250,
              touchEventsTarget: 'container', // 只在容器上监听触摸事件
              on: {
                click: function (e) {
                  e.stopPropagation(); // 阻止事件冒泡到外层轮播
                }
              },
              navigation: {
                nextEl: container.querySelector('.video-floating__products-next'),
                prevEl: container.querySelector('.video-floating__products-prev'),
              },
            });
          });
        }
        if(window && window.innerWidth <= 1000) {
          const guide = document.querySelector('.video-floating__video-guide');
          if(!window.localStorage.getItem('video-guide') && guide) {
            guide.style.display = 'flex';
            setTimeout(() => {
              guide.style.display = 'none';
              window.localStorage.setItem('video-guide', 'true');
            }, 1500);
          }
        }
      }

      bindEvents() {
        // 浮窗点击展开
        if (this.miniElement) {
          this.miniElement.addEventListener('click', () => this.expandToFullscreen());
        }

        // 全屏控制按钮
        if (this.muteBtns.length) {
          this.muteBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
              e.stopPropagation();
              this.toggleMute();
            });
          })
        }

        if (this.minimizeBtn) {
          this.minimizeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.minimizeVideo();
          });
        }

        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.closeFullscreen();
          });
        }

        // 缩小状态控制按钮
        if (this.minimizedMuteBtn) {
          this.minimizedMuteBtn.addEventListener('pointerup', (e) => {
            e.stopPropagation();
            this.toggleMute();
          });
        }

        if (this.minimizedCloseBtn) {
          this.minimizedCloseBtn.addEventListener('pointerup', (e) => {
            e.stopPropagation();
            this.closeMinimized();
          });
        }

        // 拖拽功能
        if (this.minimizedElement) {
          this.minimizedElement.addEventListener('mousedown', (e) => this.startDrag(e));
          this.minimizedElement.addEventListener('touchstart', (e) => this.startDrag(e));
          console.log(this.minimizedElement)
          // 移动端点击缩小视频进入全屏
          this.minimizedElement.addEventListener('pointerup', (e) => {
            console.log(2222222222)
            const clientX = parseInt(e.clientX || (e.touches && e.touches[0].clientX));
            const clientY = parseInt(e.clientY || (e.touches && e.touches[0].clientY));
            console.log(this.position, clientX + '-' + clientY)
            if (this.position !== clientX + '-' + clientY) return
            this.expandToFullscreen();
          });
          // this.minimizedElement.addEventListener('click', (e) => {
          //   const clientX = e.clientX || (e.touches && e.touches[0].clientX);
          //   const clientY = e.clientY || (e.touches && e.touches[0].clientY);
          //   if (this.position !== clientX + '-' + clientY) return
          //   if (!this.draggable) {
          //     this.expandToFullscreen();
          //   }
          // });
        }

        // 全局事件
        document.addEventListener('mousemove', (e) => this.drag(e));
        document.addEventListener('touchmove', (e) => this.drag(e), { passive: false });
        document.addEventListener('mouseup', () => this.stopDrag());
        document.addEventListener('touchend', () => {
          this.stopDrag()
        });
      }

      applyCustomStyles() {
        // 应用自定义样式变量
        const section = this.closest('.shopify-section');

        if (section) {
          // 设置浮窗宽度
          if (section.dataset.miniWidth) {
            document.documentElement.style.setProperty('--mini-width', `${section.dataset.miniWidth}px`);
          }

          // 设置颜色
          if (section.dataset.backgroundColor) {
            document.documentElement.style.setProperty('--background-color', section.dataset.backgroundColor);
          }

          if (section.dataset.textColor) {
            document.documentElement.style.setProperty('--text-color', section.dataset.textColor);
          }

          if (section.dataset.buttonColor) {
            document.documentElement.style.setProperty('--button-color', section.dataset.buttonColor);
          }

          // 设置z-index
          if (section.dataset.zIndex) {
            document.documentElement.style.setProperty('--mini-z-index', section.dataset.zIndex);
          }
        }
      }

      // 视频控制方法
      playMiniVideo() {
        const miniVideo = this.querySelector('.video-floating__mini-video video');
        if (miniVideo) {
          miniVideo.muted = true;
          miniVideo.play();
        }
      }

      updateActiveVideo() {
        // 暂停所有视频
        this.videoElements.forEach(video => {
          if (video !== this.getActiveVideo()) {
            video.pause();
          }
        });

        // 播放当前视频
        const activeVideo = this.getActiveVideo();
        console.log(activeVideo, 111);
        if (activeVideo) {
          activeVideo.muted = this.isMuted;
          activeVideo.play();
          activeVideo.previousElementSibling.style.display = 'none';
        }
      }

      getActiveVideo() {
        if (!this.videosSwiper) return null;

        const activeSlide = this.querySelector(`.swiper-slide:nth-child(${this.activeVideoIndex + 1}) video`);
        return activeSlide;
      }

      toggleMute() {
        this.isMuted = !this.isMuted;

        // 更新所有视频的静音状态
        this.videoElements.forEach(video => {
          video.muted = this.isMuted;
        });

        // 更新iframe视频的静音状态
        this.iframeElements.forEach(iframe => {
          try {
            const src = iframe.src;
            const newSrc = this.isMuted ?
              src.replace('&mute=0', '&mute=1') :
              src.replace('&mute=1', '&mute=0');
            iframe.src = newSrc;
          } catch (e) {
            console.error('Failed to update iframe mute state:', e);
          }
        });

        // 更新UI
        this.updateMuteUI();
      }

      updateMuteUI() {
        // 更新全屏状态的静音按钮
        if (this.muteIcons.length && this.unmuteIcons.length) {
          this.muteIcons.forEach(icon => {
            icon.style.display = this.isMuted ? 'block' : 'none';
          })
          this.unmuteIcons.forEach(icon => {
            icon.style.display = this.isMuted ? 'none' : 'block';
          })
        }

        // 更新缩小状态的静音按钮
        if (this.minimizedMuteIcon && this.minimizedUnmuteIcon) {
          this.minimizedMuteIcon.style.display = this.isMuted ? 'block' : 'none';
          this.minimizedUnmuteIcon.style.display = this.isMuted ? 'none' : 'block';
        }
      }

      // 状态转换方法
      expandToFullscreen() {
        if (this.isFullscreen) return;

        // 隐藏浮窗和缩小状态
        if (this.miniElement) this.miniElement.style.display = 'none';
        if (this.minimizedElement) this.minimizedElement.style.display = 'none';

        // 显示全屏状态
        if (this.fullscreenElement) this.fullscreenElement.style.display = 'flex';

        if (this.isInit) {
          this.initSwipers();
          this.isInit = false;
        }

        // 如果是从浮窗状态展开，默认取消静音
        if (!this.isMinimized) {
          this.isMuted = false;
          this.updateMuteUI();

          // 更新视频静音状态
          this.videoElements.forEach(video => {
            video.muted = this.isMuted;
          });

          // 更新iframe视频的静音状态
          this.iframeElements.forEach(iframe => {
            try {
              const src = iframe.src;
              iframe.src = src.replace('&mute=1', '&mute=0');
            } catch (e) { }
          });
        }
        this.isFullscreen = true;
        this.isMinimized = false;
        // 更新当前活动视频
        this.updateActiveVideo();

        // 如果有视频轮播，刷新以确保正确显示
        if (this.videosSwiper) {
          setTimeout(() => {
            this.videosSwiper.update();
          }, 100);
        }
      }

      minimizeVideo() {
        if (this.isMinimized) return;

        // 隐藏全屏和浮窗状态
        if (this.fullscreenElement) this.fullscreenElement.style.display = 'none';
        if (this.miniElement) this.miniElement.style.display = 'none';

        // 显示缩小状态
        if (this.minimizedElement) {
          this.minimizedElement.style.display = 'block';

          // 复制当前活动视频到缩小状态容器
          const minimizedVideoContainer = this.querySelector('.video-floating__minimized-video');
          const activeVideoWrapper = this.querySelector(`.video-floating__video-slide:nth-child(${this.activeVideoIndex + 1}) .video-floating__video-wrapper`);

          if (minimizedVideoContainer && activeVideoWrapper) {
            minimizedVideoContainer.innerHTML = '';
            const videoClone = activeVideoWrapper.cloneNode(true);
            minimizedVideoContainer.appendChild(videoClone);

            // 确保视频继续播放
            const video = minimizedVideoContainer.querySelector('video');
            if (video) {
              video.muted = this.isMuted;
              // video.play();
              // 根据视频播放状态设置播放状态
              if (!activeVideoWrapper.querySelector('video').paused) {
                video.play();
              }
              video.currentTime = activeVideoWrapper.querySelector('video').currentTime
              // 添加到视频元素集合中
              this.videoElements.push(video);
            }

            // 处理iframe
            const iframe = minimizedVideoContainer.querySelector('iframe');
            if (iframe) {
              this.iframeElements.push(iframe);
            }
          }
        }

        this.isFullscreen = false;
        this.isMinimized = true;
      }

      closeFullscreen() {
        // 隐藏全屏状态
        if (this.fullscreenElement) this.fullscreenElement.style.display = 'none';
        if (this.minimizedElement) this.minimizedElement.style.display = 'none';

        // 显示浮窗状态
        if (this.miniElement) this.miniElement.style.display = 'block';

        this.isFullscreen = false;
        this.isMinimized = false;

        // 恢复静音状态
        this.isMuted = true;
        this.updateMuteUI();

        // 更新视频静音状态
        this.videoElements.forEach(video => {
          video.muted = true;
        });

        // 更新iframe视频的静音状态
        this.iframeElements.forEach(iframe => {
          try {
            const src = iframe.src;
            iframe.src = src.replace('&mute=0', '&mute=1');
          } catch (e) { }
        });

        // 播放浮窗视频
        this.playMiniVideo();
      }

      closeMinimized() {
        // 与关闭全屏相同的逻辑
        this.closeFullscreen();
      }

      // 拖拽相关方法
      startDrag(e) {
        e.preventDefault();
        this.draggable = true;

        // 获取触摸或鼠标事件的坐标
        const clientX = e.clientX || (e.touches && e.touches[0].clientX);
        const clientY = e.clientY || (e.touches && e.touches[0].clientY);
        this.position = parseInt(clientX) + '-' + parseInt(clientY);
        // 计算鼠标在元素内的偏移量
        const rect = this.minimizedElement.getBoundingClientRect();
        this.dragOffsetX = clientX - rect.left;
        this.dragOffsetY = clientY - rect.top;
      }

      drag(e) {
        if (!this.draggable || !this.isMinimized) return;

        e.preventDefault();

        // 获取触摸或鼠标事件的坐标
        const clientX = e.clientX || (e.touches && e.touches[0].clientX);
        const clientY = e.clientY || (e.touches && e.touches[0].clientY);

        // 计算新位置
        const newLeft = clientX - this.dragOffsetX;
        const newTop = clientY - this.dragOffsetY;

        // 限制在视口范围内
        const maxX = window.innerWidth - this.minimizedElement.offsetWidth;
        const maxY = window.innerHeight - this.minimizedElement.offsetHeight;

        const constrainedLeft = Math.max(0, Math.min(newLeft, maxX));
        const constrainedTop = Math.max(0, Math.min(newTop, maxY));

        // 应用新位置
        this.minimizedElement.style.left = `${constrainedLeft}px`;
        this.minimizedElement.style.top = `${constrainedTop}px`;
        this.minimizedElement.style.bottom = 'auto';
        this.minimizedElement.style.right = 'auto';
      }

      stopDrag() {
        this.draggable = false;
      }

      disconnectedCallback() {
        // 清理事件监听器
        // document.removeEventListener('mousemove', this.drag);
        // document.removeEventListener('touchmove', this.drag);
        // document.removeEventListener('mouseup', this.stopDrag);
        // document.removeEventListener('touchend', this.stopDrag);
      }
    }
  );
}


